"use client"

import { GetComponentQuery, GetPageByRouteQuery } from "@eurodrive/apollo"
import { BlockRenderer } from "@eurodrive/ui"
import { getBreadCrumbs, transformProperties } from "@eurodrive/utils"

type Props = {
  data: GetPageByRouteQuery
  locale: string
  brands: GetComponentQuery
  contactForm: GetPageByRouteQuery
  carLeadType?: "sale" | "leasing"
  modelName?: string
}

// Define the components mapping object based on the block types from the query
const components = {
  heroBannerInnerPages: () => import("@eurodrive/ui/Banner"),
  selectContactForm: () => import("@eurodrive/ui/FormBlock"),
  lastSawVehicles: () => import("@eurodrive/ui/PreviouslyViewed"),
}

export default function ContactUs({
  data,
  contactForm,
  locale,
  brands,
  carLeadType,
  modelName,
}: Props) {
  const parsedData = data?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const breadCrumbs = getBreadCrumbs(data, locale)
  return (
    <>
      {blocks?.blocks?.map((block: any, index: number) => {
        let blockProps = {}
        if (block.blockType === "heroBannerInnerPages") {
          blockProps = { breadCrumbs, compact: true }
        }
        if (block.blockType === "lastSawVehicles") {
          blockProps = { brands }
        }
        if (block.blockType === "selectContactForm") {
          blockProps = { contactForm, carLeadType, modelName }
        }
        return (
          <BlockRenderer
            key={index}
            blockType={block.blockType}
            blockData={block}
            components={components}
            locale={locale}
            props={blockProps}
          />
        )
      })}
    </>
  )
}
